import { Badge } from "@loot-os/ui/components/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@loot-os/ui/components/table";

import { formatDate } from "../lib/format";
import type { UserDetail } from "../lib/trpc";
import { FraudStateBadge } from "./FraudStateBadge";
import { TableMessageRow } from "./TableMessageRow";

const COLUMNS = 6;

/** The latest fraud assessments from `users.get`: SEON's verdict per screened action. */
export function UserFraudTab({ rows }: { rows: UserDetail["risk"]["assessments"] }) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Time</TableHead>
          <TableHead>Action</TableHead>
          <TableHead>Verdict</TableHead>
          <TableHead className="text-right">Score</TableHead>
          <TableHead>Rules</TableHead>
          <TableHead>Signals</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.length === 0 && (
          <TableMessageRow colSpan={COLUMNS}>No assessments yet.</TableMessageRow>
        )}
        {rows.map((a) => (
          <TableRow key={a.id}>
            <TableCell className="text-muted-foreground">{formatDate(a.createdAt)}</TableCell>
            <TableCell>
              <Badge variant="outline">{a.action.replace("_", " ")}</Badge>
            </TableCell>
            <TableCell>
              <FraudStateBadge
                state={a.state}
                source={a.source}
                title={a.error ? `SEON: ${a.error}` : (a.seonId ?? undefined)}
              />
            </TableCell>
            <TableCell className="text-right font-mono text-xs">
              {a.fraudScore === null ? "—" : a.fraudScore.toFixed(1)}
            </TableCell>
            <TableCell className="max-w-xs truncate text-xs text-muted-foreground">
              {a.appliedRules.length === 0
                ? "—"
                : a.appliedRules.map((r) => r.name || r.id).join(", ")}
            </TableCell>
            <TableCell className="text-xs text-muted-foreground">
              {[
                a.signals.ipCountry,
                a.signals.ipVpn ? "VPN" : null,
                a.signals.ipTor ? "Tor" : null,
                a.signals.ipProxy ? "proxy" : null,
                a.signals.emailDisposable ? "disposable email" : null,
              ]
                .filter(Boolean)
                .join(" · ") || "—"}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
